import React from 'react';
import './JKBytesLogo.css';

const JKBytesLogo = ({ size = 'medium', showTagline = false, className = '' }) => {
  const sizeClasses = {
    small: 'jkbytes-logo-small',
    medium: 'jkbytes-logo-medium',
    large: 'jkbytes-logo-large',
  };

  return (
    <div className={`jkbytes-logo-container ${sizeClasses[size]} ${className}`}>
      <img className="jkbytes-logo-image" src="/tuliza.jpg" alt="Tuliza" />
      {showTagline && (
        <div className="jkbytes-tagline">Trusted UK migrant support navigator</div>
      )}
    </div>
  );
};

export default JKBytesLogo;
